import {
  SET_CURRENT_DIALOG_ID,
  SET_RECENT_DIALOG_ID_AS_CURRENT,
  SET_DIALOGS,
  SET_DIALOG_STATUS_CHANGED,
  SET_ARCHIVE_DIALOG,
  SET_UNREAD_COUNT,
} from '../actions/dialogs';

import { SET_EXPERTS } from '../actions/experts';

export const dialogsInitialState = {
  isArchiveDialog: false,
  dialogsCount: null,
  currentDialogId: null,
  dialogs: [],
  expertChanged: false,
  isDialogStatusChanged: false,
};

const dialogsReducer = (state = dialogsInitialState, { type, result, payload }) => {
  switch (type) {
    case SET_CURRENT_DIALOG_ID:
      return {
        ...state,
        // todo
        currentDialogId: payload,
      };

    case SET_RECENT_DIALOG_ID_AS_CURRENT:
      return {
        ...state,
        // todo
        currentDialogId: result && result.dialogId,
      };

    case SET_DIALOGS:
      return {
        ...state,
        dialogs: result && result.data && result.data.dialogs
      };

    case SET_EXPERTS:
      return { ...state, expertChanged: true };

    case SET_DIALOG_STATUS_CHANGED:
      if (result && result.experts){
        return { ...state };
      }
      return { ...state, isDialogStatusChanged: !state.isDialogStatusChanged };

    case SET_UNREAD_COUNT:
      if (result && result?.data?.dialogs) {
        return {
          ...state,
          dialogsCount: [...result.data.dialogs],
        };
      }
      return {
        ...state,
        dialogsCount: null,
      };

    case SET_ARCHIVE_DIALOG:
      return {
        ...state,
        isArchiveDialog: payload
      }

    default:
      return state;
  }
};

export default dialogsReducer;
